import React from 'react';

import { type VariantProps, tv } from 'tailwind-variants';

const cardVariants = tv({
  slots: {
    base: 'border border-gray-60 rounded-xl',
  },
  variants: {
    borderStyle: {
      solid: {
        base: 'border-solid',
      },
      dashed: {
        base: 'border-dashed',
      },
      dotted: {
        base: 'border-dotted',
      },
      none: {
        base: 'border-solid border-transparent',
      },
    },
  },
  defaultVariants: {
    borderStyle: 'solid',
  },
});

type CardProps = VariantProps<typeof cardVariants> & {
  className?: string;
  children: React.ReactNode;
};

const Card = ({ borderStyle, children, className }: CardProps) => {
  const styles = cardVariants({ borderStyle, className });

  return <div className={styles.base({ className })}>{children}</div>;
};

export default Card;
